/**
 * User type constants, kept dependency-free so utility modules (e.g.
 * PromotionStatusService) can import them without pulling in the route
 * config and the whole page component tree (which causes circular-import
 * "cannot access before initialization" errors).
 */
export const USER_TYPES = {
  TENANT: 'tenant',
  WHOLESALER: 'wholesaler'
};
